import React from 'react';
import TicketStubRow from '../row';
import TicketStubCell from '../cell';
import translate from '../../../../utils/translate';
import U from '../ticket_stub_utils';

const T = React.PropTypes;

export default class SectionTicket extends React.Component {
  static propTypes = {
    ticket: T.object,
    onClick: T.func
  };

  render () {
    return (
      <div>
        <TicketStubRow>
          <TicketStubCell
            isDisabled={U.isDisabled(this.props.ticket)}
            header={translate('pageTranslations', 'TICKET_STUB_SECTION')}
            text={this.props.ticket.seat_name.sec} />
        </TicketStubRow>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./frontend/react/components/common/ticket_stub/templates/section_ticket.js